import "../Styles/demo.css";
import { useState, useEffect } from "react";

import api from "./Api";

import {
  FaInstagram,
  FaTiktok,
  FaFacebookF,
  FaWhatsapp,
  FaGlobe,
  FaGoogle,
  FaYoutube,
  FaLinkedinIn,
  FaSnapchatGhost,

  
} from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";

import { useParams } from "react-router-dom";


export default function CustomerPage() {
    const [business, setBusiness] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
 const { slug } = useParams();



  useEffect(() => {
    const fetchBusiness = async () => {
      try {        
        setError("");
        const res = await api.get(`/get-business/${slug}`);

        setBusiness(res.data.business);

        if(res.data.business) {
          setLoading(false);
        }
      } catch (err) {
        setError(err.response?.data?.message || "Business not found");
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchBusiness();
    }
  }, [slug,error]);

 
useEffect(() => {
  if (!business?._id) return;

  const recordTap = async () => {
    try {
      const today = new Date().toISOString().split("T")[0];

      const storageKey = `clusterclear_tap_${business._id}`;
      const lastTap = localStorage.getItem(storageKey);

      // Already counted today
      if (lastTap === today) {
        return;
      }

      // Get or create visitor ID
      let visitorId = localStorage.getItem("clusterclear_visitor_id");

      if (!visitorId) {
        visitorId = crypto.randomUUID();

        localStorage.setItem(
          "clusterclear_visitor_id",
          visitorId
        );
      }

      await api.post("/tap-scan", {
        businessId: business._id,
        visitorId,
      });

      // Only save the date AFTER the API succeeds
      localStorage.setItem(storageKey, today);

    } catch (error) {
      console.error("Failed to record tap:", error);
    }
  };

  recordTap();

}, [business?._id]);

const handleLinkClick = async (linkType, url) => {
  try {
    await api.post("/record-click", {
      businessId: business._id,
      linkType,
    });

    console.log(`Recorded click for ${linkType} link`);
  } catch (error) {
    console.error("Failed to record click:", error);
  }

 
};
  
return loading ? (
  <div className="cc-profile-page">
    <div className="cc-profile-container">
      <div className="cc-profile-skeleton">
        <div className="cc-skeleton-avatar" />
        <div className="cc-skeleton-name" />
        <div className="cc-skeleton-title" />
        <div className="cc-skeleton-bio" />

        <div className="cc-skeleton-button" />

        {[1, 2, 3, 4, 5].map((i) => (
          <div className="cc-skeleton-row" key={i} />
        ))}
      </div>
    </div>
  </div>
) : (
  <div className="cc-profile-page">
    <div className="cc-profile-container">

      {/* PROFILE HEADER */}
      <section className="cc-profile-header">

        <div className="cc-avatar-wrapper">
          {business?.logoUrl || business?.profilePic ? (
            <img
              src={business.logoUrl || business.profilePic}
              alt={business?.businessName || "Profile"}
              className="cc-avatar"
            />
          ) : (
            <div className="cc-avatar cc-avatar-initials">
              {business?.businessName
                ?.split(" ")
                .map((word) => word[0])
                .slice(0, 2)
                .join("")
                .toUpperCase() || "C"}
            </div>
          )}

          <span className="cc-verified">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                stroke="#b89a5e"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <h1 className="cc-profile-name">
          {business?.businessName}
        </h1>

        <p className="cc-profile-title">
          {business?.title || ''}
        </p>

        {business?.about && (
          <p className="cc-profile-bio">
            {business.about || "Below are my social links and contact information. Feel free to reach out!"}
          </p>
        )}
      </section>

      {/* CONNECT BUTTON */}
      <section className="cc-connect-section">
        <button className="cc-connect-button">
          Connect with me
        </button>
      </section>

      <div className="cc-divider" />

      {/* SOCIAL */}
      <section className="cc-section">
        <p className="cc-section-heading">
          Social
        </p>

        <div className="cc-row-list">

          {business?.socialLinks?.instagram && (
            <a
              href={business.socialLinks.instagram}
              target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "instagram",
      business.socialLinks.instagram
    )
  }
            >
              <span className="cc-row-icon">
                <FaInstagram />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  Instagram
                </span>

                <span className="cc-row-subtitle">
                  Follow me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.socialLinks?.tiktok && (
            <a
              href={business.socialLinks.tiktok}
               target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "tikTok",
      business.socialLinks.tiktok
    )
  }
            >
              <span className="cc-row-icon">
                <FaTiktok />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  TikTok
                </span>

                <span className="cc-row-subtitle">
                  Follow me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.socialLinks?.facebook && (
            <a
              href={business.socialLinks.facebook}
             target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "facebook",
      business.socialLinks.facebook
    )
  }
            >
              <span className="cc-row-icon">
                <FaFacebookF />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  Facebook
                </span>

                <span className="cc-row-subtitle">
                  Connect with me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.socialLinks?.youtube && (
            <a
              href={business.socialLinks.youtube}
             target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "youtube",
      business.socialLinks.youtube
    )
  }
            >
              <span className="cc-row-icon">
                <FaYoutube />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  YouTube
                </span>

                <span className="cc-row-subtitle">
                  Subscribe
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.socialLinks?.linkedin && (
            <a
              href={business.socialLinks.linkedin}
             target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "linkedIn",
      business.socialLinks.LinkedIn
    )
  }
            >
              <span className="cc-row-icon">
                <FaLinkedinIn />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  LinkedIn
                </span>

                <span className="cc-row-subtitle">
                  Connect with me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.socialLinks?.snapchat && (
            <a
              href={business.socialLinks.snapchat}
              target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "snapchat",
      business.socialLinks.snapchat
    )
  }
            >
              <span className="cc-row-icon">
                <FaSnapchatGhost />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  Snapchat
                </span>

                <span className="cc-row-subtitle">
                  Follow me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}
          {business?.socialLinks?.x && (
            <a
              href={business.socialLinks.x}
            
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "x",
      business.socialLinks.x
    )
  }
            >
              <span className="cc-row-icon">
                <FaXTwitter />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  X
                </span>

                <span className="cc-row-subtitle">
                  Follow me
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

        </div>
      </section>

      {/* CONTACT */}
      <section className="cc-section">
        <p className="cc-section-heading">
          Contact
        </p>

        <div className="cc-row-list">

          {business?.whatsappNumber && (
            <a
              href={`https://wa.me/${business.whatsappNumber}`}
             target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "whatsapp",
      business.socialLinks.whatsappNumber
    )
  }
            >
              <span className="cc-row-icon cc-whatsapp">
                <FaWhatsapp />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  WhatsApp
                </span>

                <span className="cc-row-subtitle">
                  Let's connect
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.email && (
            <a
              href={`mailto:${business.email}`}
                target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "email",
      business.socialLinks.email
    )
  }
            >
              <span className="cc-row-icon">
                ✉
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  Email
                </span>

                <span className="cc-row-subtitle">
                  {business.email}
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

          {business?.website && (
            <a
              href={business.website}
             target="_blank"
              rel="noreferrer"
              className="cc-profile-row"
              onClick={() =>
    handleLinkClick(
      "website",
      business.socialLinks.website
    )
  }
            >
              <span className="cc-row-icon">
                <FaGlobe />
              </span>

              <span className="cc-row-content">
                <span className="cc-row-title">
                  Website
                </span>

                <span className="cc-row-subtitle">
                  {business.website.replace(/^https?:\/\//, "")}
                </span>
              </span>

              <span className="cc-chevron">›</span>
            </a>
          )}

        </div>
      </section>

      {/* GOOGLE REVIEW */}
      {business?.reviewLinks?.google && (
        <section className="cc-section">

          <p className="cc-section-heading">
            Reviews
          </p>

          <a
            href={business.reviewLinks.google}
            target="_blank"
            rel="noreferrer"
            className="cc-profile-row"
            onClick={() =>
    handleLinkClick(
      "google",
      business.socialLinks.google
    )
  }
          >
            <span className="cc-row-icon">
              <FaGoogle />
            </span>

            <span className="cc-row-content">
              <span className="cc-row-title">
                Google Review
              </span>

              <span className="cc-row-subtitle">
                Share your experience
              </span>
            </span>

            <span className="cc-chevron">›</span>
          </a>

        </section>
      )}

      {/* FEATURED */}
      <section className="cc-section cc-featured-section">

        <p className="cc-section-heading">
          Featured
        </p>

        <div className="cc-featured-card">

 <h3>
            ClusterClear
          </h3>
          <p className="cc-featured-label">
            Tap. Connect. Grow.
          </p>

         

          <p className="cc-featured-description">
            Helping people carry their business with them wherever they go.
          </p>

          <a
            href='https://clusterclear.app/product'
            target="_blank"
            rel="noreferrer"
            className="cc-featured-link"
          >
            Join Us.
            <span>›</span>
          </a>

        </div>

      </section>

      {/* FOOTER */}
      <footer className="cc-profile-footer">
        Powered by{" "}
        <a
          href='https://clusterclear.app/product'
          target="_blank"
          rel="noreferrer"
        >
          ClusterClear
        </a>
      </footer>

    </div>
  </div>
);
}